import React, { useState } from "react";
import { perPageOptions } from "../contants/data";
import Select from "react-select";

const PerPage = ({ onChangePage }) => {
  const [selectedPerPage, setSelectedPerPage] = useState(perPageOptions[0]);

  const handlePerPageChange = (option) => {
    setSelectedPerPage(() => option);
    onChangePage(option);
  };

  return (
    <div>
      <Select
        options={perPageOptions}
        onChange={handlePerPageChange}
        value={selectedPerPage}
        className="border-0"
      />
    </div>
  );
};

export default PerPage;
